import LoginButton from './LoginButton';
import enhance from './LoginButtonContainer';

export default enhance(LoginButton);
